import React from "react";
import BasePage from "components/BasePage";
import ConferenceStreamController from "./components/ConferenceStreamController";
import "./style.scss";
import useController from "./controller";

interface Props {
  conferenceUuid: string;
}

export default function PageConferenceChat({ conferenceUuid }: Props) {
  const { loading, ownerId, groupId, livechatSubject, onClose, groupThreadId } = useController({ conferenceUuid });

  return (
    <BasePage className="page-conference-chat" loading={loading}>
      {livechatSubject && (
        <ConferenceStreamController
          livechatSubject={livechatSubject}
          conferenceUuid={conferenceUuid}
          ownerId={ownerId}
          groupId={groupId}
          onClose={onClose}
          groupThreadId={groupThreadId}
        />
      )}
    </BasePage>
  );
}
